import React, { FC } from "react";
import cn from "classnames";
import { ValueType } from "../data";

interface LoanToValueCalculatorResults {
    resultType: string;
    shouldAnimate: boolean;
    results: string[];
}

export const LoanToValueCalculatorResults: FC<LoanToValueCalculatorResults> = ({
  resultType, shouldAnimate, results,
}) => {
  const [result1, result2] = results;
  const titleClassName = cn("loan-to-value-calculator-result__title", {
    "loan-to-value-calculator-result__title-animated": shouldAnimate,
  });
  const amountClassName = "loan-to-value-calculator-amount loan-to-value-calculator-amount-animated";

  return (
    <div className="loan-to-value-calculator-results">
      <div className="loan-to-value-calculator-result">
        <p className={titleClassName}>
          {resultType === ValueType.DEPOSIT_AMOUNT ? "Loan to value:" : null}
          {resultType === ValueType.LOAN_AMOUNT ? "Loan to value:" : null}
          {resultType === ValueType.LTV_PERCENTAGE ? "Loan amount:" : null}
        </p>
        <p className={amountClassName}>{result1 || "-"}</p>
      </div>
      <div className="loan-to-value-calculator-result">
        <p className={titleClassName}>
          {resultType === ValueType.DEPOSIT_AMOUNT ? "Loan amount:" : null}
          {resultType === ValueType.LOAN_AMOUNT ? "Deposit amount:" : null}
          {resultType === ValueType.LTV_PERCENTAGE ? "Deposit amount:" : null}
        </p>
        <p className={amountClassName}>{result2 || "-"}</p>
      </div>
    </div>
  );
};
